module.exports = __webpack_public_path__ + "assets/img/DS-corridors (3).f0e8680c.jpg";